import { ThemeColorVariable as r } from "../../theme/theme-types.js";
import { Icons as n } from "../icon/types.js";
const o = (e) => {
  switch (e) {
    case "info":
      return r.OnInfoContainer;
    case "error":
      return r.OnErrorContainer;
    case "warning":
      return r.OnWarningContainer;
    case "neutral":
      return r.OnNeutralContainer;
    case "success":
    default:
      return r.OnSuccessContainer;
  }
}, c = (e) => {
  switch (e) {
    case "info":
      return r.InfoContainer;
    case "error":
      return r.ErrorContainer;
    case "warning":
      return r.WarningContainer;
    case "neutral":
      return r.NeutralContainer;
    case "success":
    default:
      return r.SuccessContainer;
  }
}, s = (e) => {
  switch (e) {
    case "warning":
      return n.TriangleWarning;
    case "success":
      return n.CircleSuccess;
    case "error":
      return n.HexagonError;
    default:
      return n.CircleInfo;
  }
};
export {
  c as getAlertBackgroundColor,
  s as getAlertIcon,
  o as getAlertTextColor
};
